<div class="ir-area ir-header th-header">
  <div class="ir-line th-header-line clickable" *ngIf="!showSearch">
    <div class="ir-line--left">
      <div class="ir-btn th-btn-normal" (click)="goToBack()">
        <i class="material-icons">arrow_back</i>
      </div>
    </div>
    <div class="ir-line--right" *ngIf="inspection">
      <div class="ir-btn th-btn-normal black" (click)="gotoValidationSummaryPage()">
        <i class="material-icons-outlined">assignment_turned_in</i>
        <span class="th-btn-badge success" *ngIf="!errorMessage"><i class="material-icons">done</i></span>
        <span class="th-btn-badge error" *ngIf="errorMessage">{{ validatedPlugins.length > 9 ? '9+' : validatedPlugins.length }}</span>
      </div>
      <div class="th-header-divider"></div>
      <div class="ir-btn th-btn-icon" *ngIf="!isConnection">
        <i class="material-icons">portable_wifi_off</i>
      </div>
      <div class="ir-btn th-btn-icon" *ngIf="inspection?.isOffline">
        <i class="material-icons warning" *ngIf="inspection?.updatedOffline">offline_pin</i>
        <i class="material-icons offline" *ngIf="!inspection?.updatedOffline">offline_pin</i>
      </div>
      <div class="ir-btn th-btn-icon" *ngIf="!inspection?.isOffline && inspection?.isSynchronizing">
        <i class="material-icons offline">sync</i>
      </div>
      <div class="ir-btn th-btn-normal" (click)="gotoInformationPage()">
        <i class="material-icons">contacts</i>
      </div>
      <div class="ir-btn th-btn-normal" (click)="refreshPage()">
        <i class="material-icons">refresh</i>
      </div>
      <div class="ir-btn th-btn-normal" (click)="updateShowSearch()">
        <i class="material-icons">search</i>
      </div>
      <div class="ir-btn th-btn-normal" [permissions]="[['visible', 'inspection.offline.menu', inspection]]" (click)="openMenu()">
        <i class="material-icons">more_vert</i>
      </div>
    </div>
    <div class="ir-line-content" (click)="gotoEditPage()">
      <span
        >{{ inspection?.name }} <strong>({{ inspection?.sections?.length }})</strong></span
      >
    </div>
  </div>
  <div class="ir-line th-header-search" *ngIf="showSearch">
    <div class="ir-line--left">
      <div class="ir-btn th-btn-unactive">
        <i class="material-icons">search</i>
      </div>
    </div>
    <div class="ir-line--right">
      <div class="ir-btn th-btn-search" (click)="updateShowSearch(false)">
        <i class="material-icons">close</i>
      </div>
    </div>
    <div class="ir-line-content">
      <input
        autoFocus
        type="search"
        name="Search"
        placeholder="{{ 'common.placeholders.search' | translate }}"
        [(ngModel)]="query"
        focus="showSearch"
      />
    </div>
  </div>
</div>
<div class="ir-area ir-body th-body">
  <div class="th-loading" *ngIf="loading">
    <span>{{ 'common.loading' | translate }}...</span>
  </div>
  <div class="ir-section--list">
    <div class="ir-line ir-line-title">
      <ng-container *ngIf="!inspection?.isOffline && isConnection && inspection?.technicienId && currentStatusFlow">
        <div class="ir-line--right">
          <button
            *ngIf="currentStatusFlow.next && !currentStatusFlow.manager"
            class="ir-btn ir-btn--block ir-btn--title th-btn-action ir-txt--right"
            (click)="updateStatus(currentStatusFlow.next)"
          >
            <span>{{ currentStatusFlow.button | translate }}</span>
          </button>
          <button
            *ngIf="currentStatusFlow.next && currentStatusFlow.manager"
            [permissions]="[['visible', 'manage.inspection.status']]"
            class="ir-btn ir-btn--block ir-btn--title th-btn-action ir-txt--right"
            (click)="updateStatus(currentStatusFlow.next)"
          >
            <span>{{ currentStatusFlow.button | translate }}</span>
          </button>
        </div>
        <div class="ir-line--right">
          <button
            *ngIf="currentStatusFlow.previous"
            class="ir-btn ir-btn--block ir-btn--title th-btn-modal ir-txt--right"
            (click)="updateStatus(-currentStatusFlow.previous)"
          >
            <i class="material-icons" style="margin-right: 8px; font-size: 4em">arrow_back_ios</i>
            <span>{{ currentStatusFlow.backButton | translate }}</span>
          </button>
        </div>
      </ng-container>
      <div class="ir-line--right" *ngIf="offlinePerson">
        <div class="ir-btn--title ir-text-title offline">
          <span>{{ 'offline.saved-locally-by' | translate : offlinePerson }}</span>
        </div>
      </div>
      <div class="ir-line--right">
        <ng-container *ngFor="let session of inspection?.sessions">
          <i
            *ngIf="session.user"
            (click)="navigateToSession(session)"
            [title]="session.user"
            class="material-icons session"
            [style.color]="session.color"
            [class.disabled]="session.away"
            [class.away]="session.away"
            [class.active]="!session.away"
            >account_circle
          </i>
        </ng-container>
      </div>
      <div class="ir-line-content">
        <span>{{ 'inspections.sections' | translate }}</span>
      </div>
    </div>
    <inspection-detail
      [inspection]="inspection"
      (toggleOpenSection)="openSection($event)"
      (toggleSelectSection)="selectSection($event)"
      [query]="query"
    ></inspection-detail>
  </div>
</div>

<modal (modalOutput)="selectMenu($event)"></modal>
<modal #partsModal></modal>

<input type="file" #fileInput style="display: none" (change)="upload($event)" multiple="true" />
<input type="file" #pricesInput style="display: none" (change)="uploadPartPrices($event)" multiple="true" />
<confirm
  #deleteConfirm
  (confirmOutput)="deleteInspection($event)"
  [title]="'common.delete-confirmation' | translate"
  [message]="'inspections.sure-to-delete' | translate"
  [danger]="true"
></confirm>
<confirm
  #sendToValidateConfirm
  (confirmOutput)="sendToValidate($event)"
  [title]="'inspections.send-to-validate' | translate"
  [message]="'inspections.sure-to-validate' | translate"
></confirm>
<order-summaries
  #orderSections
  [title]="'templates.order-sections' | translate"
  (toggleSave)="saveSectionsOrder($event)"
  (toggleCancel)="cancel()"
></order-summaries>
<order-summaries
  #orderPlugins
  [title]="'templates.order-plugins' | translate"
  (toggleSave)="savePluginsOrder($event)"
  (toggleCancel)="close()"
></order-summaries>

<inputlang
  #languagesModal
  (modalOutput)="selectLanguagesMenu($event)"
  [title]="'inspections.change-input-lang' | translate"
  [message]="'inspections.change-input-lang-warning' | translate"
  [danger]="true"
></inputlang>
<modal (modalOutput)="setReportLang($event.value)" #reportLangModal></modal>
<information
  #inspectionCopy
  [title]="'offline.inspection-copy-modal.title' | translate"
  [message]="inspectionCopyMessage | translate : loadedData"
  [danger]="true"
></information>
<confirm
  #offlineRemoveConfirm
  (confirmOutput)="removeFromOffline()"
  [title]="'offline.inspection-remove-modal.title' | translate"
  [message]="'offline.inspection-remove-modal.message' | translate"
  [okButtonText]="'offline.inspection-remove-modal.remove-anyway' | translate"
  [danger]="true"
></confirm>
<information
  #availableOfflineConfirm
  [title]="'offline.inspection-available-offline.title' | translate"
  [message]="'offline.inspection-available-offline.message' | translate : offlineInspection"
  [danger]="true"
></information>
<information
  #synchronizationModal
  [title]="'offline.inspection-syncronization-modal.title' | translate"
  [message]="'offline.inspection-syncronization-modal.message' | translate : syncData"
  [danger]="true"
></information>
<confirm
  #synchronizationCompleted
  (confirmOutput)="continueLocally()"
  (modalClosed)="deleteLocal()"
  [title]="'offline.inspection-syncronization-modal.title' | translate"
  [message]="'offline.inspection-syncronization-completed.message' | translate"
  [okButtonText]="'offline.inspection-syncronization-completed.ok' | translate"
  [cancelButtonText]="'offline.inspection-syncronization-completed.cancel' | translate"
  [danger]="true"
></confirm>
<confirm
  #sectionsDeleteConfirm
  (confirmOutput)="deleteSections($event)"
  [title]="'common.delete-confirmation' | translate"
  [message]="'sections.sure-to-delete-sections' | translate"
  [danger]="true"
></confirm>
<information
  #synchronizationErrorModal
  [title]="'offline.inspection-syncronization-modal.title' | translate"
  [message]="'offline.inspection-syncronization-modal.error-message' | translate"
  [danger]="true"
></information>
<confirm-with-options
  #clipboardPasteReplaceConfirm
  (confirmOutput)="paste($event)"
  [okButtonsSettings]="[
    { text: 'common.replace' | translate, value: true, buttonClass: 'th-btn-remove' },
    { text: 'common.ok' | translate, value: false, buttonClass: 'th-btn-modal--action' }
  ]"
  [title]="'common.paste-confirmation' | translate"
  [message]="'common.sure-to-replace-items' | translate"
></confirm-with-options>
<confirm
  #statusUpdateConfirm
  (confirmOutput)="finishStatusUpdate()"
  [title]="'inspections.update-status.title' | translate"
  [okButtonText]="updateStatusOkButton | translate"
  [message]="updateStatusMessage"
  [cancelButtonText]="'inspections.update-status.later' | translate"
  [center]="false"
  [danger]="true"
></confirm>

<confirm
  #sapSynchronizationConfirm
  (confirmOutput)="synchronizeSapAndOpenReport()"
  (modalClosed)="openReportLangModal()"
  [title]="'inspections.parts.report-price-synchronization-title' | translate"
  [message]="'inspections.parts.report-price-synchronization-text' | translate"
></confirm>
<confirm
  #updateFromMachineModuleConfirm
  (confirmOutput)="updateFromMachineModule()"
  [title]="'inspections.machine-module.update-inspection.title' | translate"
  [message]="'inspections.machine-module.update-inspection.text' | translate"
></confirm>
<confirm
  #updateMachineModuleConfirm
  (confirmOutput)="updateMachineModule()"
  [title]="'inspections.machine-module.update-module.title' | translate"
  [message]="'inspections.machine-module.update-module.text' | translate"
></confirm>

<information
  #priceSynchronizationErrorModal
  [title]="'inspections.parts.report-price-synchronization-title' | translate"
  [message]="
    'inspections.parts.report-price-currency-mismatch' | translate : { inspectionCurrency: inspection?.currency, sapCurrency: sapCurrency }
  "
  [danger]="true"
></information>
